'use strict';

var React = require('react');
var HCAvatar = require('../Avatar/HCAvatar.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var ListItem = require('../../node_modules/@material-ui/core/esm/ListItem/ListItem.js');
var Checkbox = require('../../node_modules/@material-ui/core/esm/Checkbox/Checkbox.js');
var ListItemText = require('../../node_modules/@material-ui/core/esm/ListItemText/ListItemText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles() {
  return {
    checkbox: {
      position: 'relative',
      right: 16
    },
    avatar: {
      position: 'relative',
      right: 20
    },
    listText: {
      position: 'relative',
      right: 10
    },
    denselistText: {
      fontSize: 14
    },
    denseCheckbox: {
      padding: 0
    }
  };
};

var EmployeeSelectionListItem = function EmployeeSelectionListItem(_ref) {
  var avatarUrl = _ref.avatarUrl,
      colorHex = _ref.colorHex,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      title = _ref.title,
      classes = _ref.classes,
      checked = _ref.checked,
      disabled = _ref.disabled,
      showAvatar = _ref.showAvatar,
      proId = _ref.proId,
      dense = _ref.dense,
      handleToggle = _ref.handleToggle;
  return React__default["default"].createElement(ListItem["default"], {
    button: true,
    onClick: handleToggle(proId),
    disabled: disabled
  }, React__default["default"].createElement(Checkbox["default"], {
    tabIndex: -1,
    disableRipple: true,
    className: dense ? classes.denseCheckbox : classes.checkbox,
    checked: checked.indexOf(proId) !== -1,
    style: {
      color: colorHex
    }
  }), showAvatar && React__default["default"].createElement(HCAvatar, {
    avatarUrl: avatarUrl,
    firstName: firstName,
    lastName: lastName,
    className: classes.avatar
  }), React__default["default"].createElement(ListItemText["default"], {
    primary: "".concat(firstName, " ").concat(lastName),
    secondary: title,
    className: dense ? classes.denselistText : classes.listText
  }));
};

var EmployeeSelectionListItem$1 = withStyles(styles)(EmployeeSelectionListItem);
EmployeeSelectionListItem.defaultProps = {
  dense: false,
  showAvatar: true
};

module.exports = EmployeeSelectionListItem$1;
